module.exports = __webpack_public_path__ + "static/media/start-car-speech.755e4041.mp3";